import {
  icon as renderIcon,
  type IconDefinition,
} from '@fortawesome/fontawesome-svg-core';
import {
  faPaintBrush,
  faEraser,
  faFillDrip,
  faEyeDropper,
  faArrowPointer,
  faArrowDown,
  faArrowUp,
  faBorderAll,
  faBorderNone,
  faSquareFull,
  faDrawPolygon,
  faMagnet,
  faClone,
  faHand,
  faLayerGroup,
  faLock,
  faLockOpen,
  faEye,
  faEyeSlash,
  faFileExport,
  faFloppyDisk,
  faImage,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faPlay,
  faPlus,
  faRotateLeft,
  faRotateRight,
  faTrash,
  faUpDownLeftRight,
  faWandMagicSparkles,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

const icons = {
  terrain: faWandMagicSparkles,
  'terrain-erase': faEraser,
  'tile-select': faBorderNone,
  brush: faPaintBrush,
  eraser: faEraser,
  fill: faFillDrip,
  rectangle: faSquareFull,
  eyedropper: faEyeDropper,
  add: faPlus,
  arrowDown: faArrowDown,
  arrowUp: faArrowUp,
  assets: faImage,
  delete: faTrash,
  export: faFileExport,
  hide: faEyeSlash,
  grid: faBorderAll,
  snap: faMagnet,
  collisions: faDrawPolygon,
  duplicate: faClone,
  layers: faLayerGroup,
  lock: faLock,
  unlock: faLockOpen,
  pan: faHand,
  move: faUpDownLeftRight,
  particle: faWandMagicSparkles,
  play: faPlay,
  redo: faRotateRight,
  rotate: faRotateRight,
  save: faFloppyDisk,
  select: faArrowPointer,
  undo: faRotateLeft,
  visible: faEye,
  close: faXmark,
  zoomIn: faMagnifyingGlassPlus,
  zoomOut: faMagnifyingGlassMinus,
} satisfies Record<string, IconDefinition>;

export function icon(name: keyof typeof icons, label?: string): string {
  return renderIcon(icons[name], {
    attributes:
      label === undefined
        ? { 'aria-hidden': 'true', focusable: 'false' }
        : { 'aria-label': label, role: 'img' },
  }).html.join('');
}
